import {BaseConfig} from "../../infrastructure/config/base-config";
import {ScoresListWidgetTerms} from "./scores-list-widget.terms";
import {APP} from "../../core/app/consts";

export class ScoresListWidgetConfig extends BaseConfig {
  desktopCompetitionsLimit: Number;
  mobileCompetitionsLimit: Number;
  nextDaysAmountToBeLink: Number;
  prevDaysAmountToBeLink: Number;
  source: APP.ANALYTICS.SOURCES;

  static injectables = [ScoresListWidgetTerms];

  constructor(terms: ScoresListWidgetTerms) {
    super('scoresListWidget', null, terms);

    this.desktopCompetitionsLimit = 15;
    this.mobileCompetitionsLimit = 10;
    this.prevDaysAmountToBeLink = -7;
    this.nextDaysAmountToBeLink = 30;
    this.source = APP.ANALYTICS.SOURCES.scoresList;
  }
}
